import DatePicker from 'vue2-datepicker';
import commonHelper from '@/app/utility/common.helper.utility';
import addEditComponentGroup from './addEditComponentGroup';
export default {
  name: 'componentGroup',
  components: {
    DatePicker,
    addEditComponentGroup
  },
  props: ['showCompGroup'],
  watch: {
    currentPage: function() {
      this.getComponentGroupList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getComponentGroupList();
    }
  },
  data() {
    return {
      selectedCompGroupData: null,
      showComponentGroupModal: false,
      loader: false,
      unsubscribe: null,
      totalRows: null,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      componentGroup: null,
      groupCode: null,
      groupName: null,
      payload: {},
      displayName: null,
      startDate: null,
      endDate: null,
      penaltyTermList: [],
      componentGroupData: [],
      componentGroupFields: [
        {
          key: 'group_code'
        },
        {
          key: 'group_name'
        },
        {
          key: 'group_display_name',
          label: 'Display Name'
        },
        {
          key: 'group_start_date',
          label: 'Start Date'
        },
        {
          key: 'group_end_date',
          label: 'End Date'
        }
      ],
      active: true,
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.selectedCompGroupData = null;
          this.showhideCompModal(true);
        }
        if (actionName === 'download' && !this.showComponentGroupModal) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'masterData/getComponentGroupList',
            'component-group',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  methods: {
    getComponentGroupList() {
      this.payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        group_code: this.groupCode,
        group_name: this.groupName,
        group_display_name: this.displayName,
        group_start_date: this.startDate,
        group_end_date: this.endDate,
        active:this.active
      };
      this.loader = true;
      this.$store
        .dispatch('masterData/getComponentGroupList', this.payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.componentGroupData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showhideCompModal(flag) {
      this.showComponentGroupModal = flag;
    },
    rowSelected(item) {
      this.selectedCompGroupData = item;
      this.showhideCompModal(true);
      // this.selectedCompGroupData = { ...item };
      // if (this.showCompGroup) {
      //   this.$emit('selectedCompGroup', this.selectedCompGroupData);
      // } else {
      //   this.showComponentGroupModal = true;
      // }
    },
    clearSearch() {
      this.groupCode = null;
      this.groupName = null;
      this.displayName = null;
      this.startDate = null;
      this.endDate = null;
      this.componentGroupData = null;
      this.totalRows = null;
    },
    disabledDates(date) {
      return commonHelper.disabledDates(date, this.startDate);
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
